const meeting = {
  path: 'meeting/:courseId',
  component: resolve => require(['../../../pages/user/meeting'], resolve),
  props: true
}

export default meeting



// WEBPACK FOOTER //
// ./src/router/user/meeting/index.js